<template>
  <OnChartMessage
    v-model="showMessage"
    show-close-button
    min-width="280px"
    class="deadline-message"
    @click.stop="onClickMessage">
    <template v-if="deadlineDiff > 0">
      <span class="deadline-message__underline">前月の自己評価はこちらから</span><br>
      残り{{ deadlineDiff }}日
    </template>
    <template v-else>
      <span class="deadline-message__underline">
        提出期限を過ぎました。<br>
        前月の自己評価はこちらから
      </span>
    </template>
  </OnChartMessage>
</template>

<script>
import { differenceInDays, setDate, isSameMonth, endOfMonth } from 'date-fns'
import OnChartMessage from '@/components/parts/OnChartMessage.vue'
export default {
  components: {
    OnChartMessage,
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    lastYearMonth: {
      type: String,
      required: true
    },
    mandalaGoalTemplate: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showMessage: true
    }
  },
  computed: {
    today() {
      return new Date() 
    },
    deadlineDiff() {
      const { monthlyDeadlineDay } = this.mandalaGoalTemplate
      const setDayDate = setDate(this.today, monthlyDeadlineDay)
      const deadlineDate = isSameMonth(this.today, setDayDate) ? setDayDate : endOfMonth(this.today)
      // 本日を含んだ日数にするために+1する
      return differenceInDays(deadlineDate, this.today) + 1
    },
  },
  methods: {
    onClickMessage() {
      this.$router.push({
        path: `/members/${this.userId}/mandala_evaluation`,
        query: {
          yearMonth: this.lastYearMonth
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.deadline-message {
  cursor: pointer;

  &__underline {
    text-decoration: underline;
  }
}
</style>